import { useEffect, useState } from "react";
import "./blc_reservation.css";
import {
  Container,
  Row,
  Col,
  Form,
  Button,
} from "react-bootstrap";
import { Parallax } from "react-parallax";
import Blc_partner from "../Blc_Home/Blc_partner/Blc_partner";
import Blc_map from "../Blc_Home/Blc_map/Blc_map";
import axios from 'axios';
import { BlcNotificationOne, BlcNotificationTwo } from "./Blc_Notification";
import 'react-toastify/dist/ReactToastify.css';
import { Helmet } from "react-helmet";


// NO HERO SECTION WILL APPEAR ON RESERVATION PAGE //

const Blc_Reservation = (props) => {
  const [checkInDate, setCheckInDate] = useState('');
  const [checkOutDate, setCheckOutDate] = useState('');
  const [firstName, setFristName] = useState('');
  const [lastName, setLastName] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [userEmail, setUserEmail] = useState('');
  const [companyName, setCompanyName] = useState('');
  const [streetAddress, setStreetAddress] = useState('');
  const [streetAddressTwo, setStreetAddressTwo] = useState('');
  const [cityName, setCityName] = useState('');
  const [serviceType, setServiceType] = useState('');
  const [roomType, setRoomType] = useState('');
  const [locationType, setLocationType] = useState('');
  const [numberOfRoom, setNumberOfRoom] = useState('');
  const [numberOfPerson, setNumberOfPerson] = useState('');
  const [visitPurpose, setVisitPurpose] = useState('');
  const [specialRequest, setSpecialRequest] = useState('');
  const [termCondition, setTermCondition] = useState('yes');
  const [mailToast, setMailToast] = useState(false);
  const [mailToastErr, setMailToastErr] = useState(false);


  const [validated, setValidated] = useState(false);
  useEffect(() => {

  }, [mailToast, mailToastErr]);

  const handleSubmit = (event) => {
    event.preventDefault();
    event.stopPropagation();
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
      setValidated(true)
    }

    if (form.checkValidity() === true) {
      let userInput = {
        firstName: firstName,
        lastName: lastName,
        phone: phoneNumber,
        email: userEmail,
        companyName: companyName,
        addressOne: streetAddress,
        addressTwo: streetAddressTwo,
        city: cityName,
        service: serviceType,
        roomtype: roomType,
        location: locationType,
        rooms: numberOfRoom,
        persons: numberOfPerson,
        checkIn: checkInDate,
        checkOut: checkOutDate,
        purpose: visitPurpose,
        request: specialRequest,
        codition: termCondition,

      };

      axios.post('https://blc.brac.net/reservation', userInput).then(response => {

        setMailToast(true)
        //http://localhost:3000/reservation
        //https://blc.brac.net/reservation

        // console.log(response);
      }).catch(err => {

        setMailToastErr(true);

      });

      setCheckInDate('');
      setCheckOutDate('');
      setFristName('');
      setLastName('');
      setPhoneNumber('');
      setUserEmail('');
      setCompanyName('');
      setStreetAddress('');
      setStreetAddressTwo('');
      setCityName('');
      setServiceType('');
      setRoomType('');
      setLocationType('');
      setNumberOfRoom('');
      setNumberOfPerson('');
      setVisitPurpose('');
      setSpecialRequest('');
      setTermCondition('');
      setValidated(false);


    }


  };

  const dateOneHandler = (event) => {
    // console.log(event.target.value[6]);
    // console.log(event.target.value);

    setCheckInDate(event.target.value);
    setMailToast(false);
    setMailToastErr(false);
    // console.log(checkInDate);
    // console.log(new Date(checkInDate));
  }
  const dateTwoHandler = (event) => {
    setCheckOutDate(event.target.value);
    setMailToast(false);
    setMailToastErr(false);
  }

  const firstNameHandler = (event) => {
    setMailToast(false);
    setMailToastErr(false);
    setFristName(event.target.value);
  }
  const lastNameHandler = (event) => {
    setMailToast(false);
    setMailToastErr(false);
    setLastName(event.target.value);
  }

  const phoneNumberHandler = (event) => {
    setMailToast(false);
    setMailToastErr(false);
    setPhoneNumber(event.target.value);
  }
  const emailHandler = (event) => {
    setMailToast(false);
    setMailToastErr(false);
    setUserEmail(event.target.value);
  }

  const companynameHandler = (event) => {
    setMailToast(false);
    setMailToastErr(false);
    setCompanyName(event.target.value);
  }
  const streetAddressOneHandler = (event) => {
    setMailToast(false);
    setMailToastErr(false);
    setStreetAddress(event.target.value);
  }
  const streetAddressTwoHandler = (event) => {
    setMailToast(false);
    setMailToastErr(false);
    setStreetAddressTwo(event.target.value);
  }

  const cityNameHandler = (event) => {
    setMailToast(false);
    setMailToastErr(false);
    setCityName(event.target.value);
  }
  const serviceTypeHandler = (event) => {
    setMailToast(false);
    setMailToastErr(false);
    setServiceType(event.target.value);
  }
  const roomTypeHandler = (event) => {
    setMailToast(false);
    setMailToastErr(false);
    setRoomType(event.target.value);
  }
  const locationHandler = (event) => {
    setMailToast(false);
    setMailToastErr(false);
    setLocationType(event.target.value);
  }

  const numberOfRoomHandler = (event) => {
    setMailToast(false);
    setMailToastErr(false);
    setNumberOfRoom(event.target.value);
  }

  const numberOfPersonHandler = (event) => {
    setMailToast(false);
    setMailToastErr(false);
    setNumberOfPerson(event.target.value);
  }
  const visitPurposeHandler = (event) => {
    setMailToast(false);
    setMailToastErr(false);
    setVisitPurpose(event.target.value);
  }

  const specialRequestHandler = (event) => {
    setMailToast(false);
    setMailToastErr(false);
    setSpecialRequest(event.target.value);
  }
  const termConditionHandler = (event) => {
    setMailToast(false);
    setMailToastErr(false);
    setTermCondition('yes');
  }

  //Date disable function.
  const disablePastDate = () => {
    const today = new Date();
    // console.log(today);
    // console.log(today.getMonth());
    const dd = String(today.getDate()).padStart(2, "0");
    const mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
    const yyyy = today.getFullYear();
    return yyyy + "-" + mm + "-" + dd;
  };
  // Disable checkout Date
  const blcCheckout = () => {
    const today = new Date(checkInDate);
    // console.log( typeof(today.getDate()))
    // console.log(typeof(30));
    // console.log(today.getMonth());
    // console.log(today.getMonth()%2);
    if (((today.getDate() == 30) && (today.getMonth() % 2 == 1))) {
      const today = new Date(checkInDate);
      const dd = String((0 + 1)).padStart(2, "0");
      const mm = String(today.getMonth() + 2).padStart(2, "0"); //January is 0!
      const yyyy = today.getFullYear();
      // console.log("this code run one")
      // console.log(yyyy + "-" + mm + "-" + dd)
      return yyyy + "-" + mm + "-" + dd;


    } else if (((today.getDate() == 30) && (today.getMonth() % 2 == 0))) {
      const today = new Date(checkInDate);
      const dd = String((0 + 1)).padStart(2, "0");
      const mm = String(today.getMonth() + 2).padStart(2, "0"); //January is 0!
      const yyyy = today.getFullYear();
      // console.log("this code run one")
      // console.log(yyyy + "-" + mm + "-" + dd)
      return yyyy + "-" + mm + "-" + dd;


    }
    else if (((today.getDate() == 31) && (today.getMonth() % 2 == 0))) {
      const today = new Date(checkInDate);
      // console.log(today.getMonth());
      const dd = String((0 + 1)).padStart(2, "0");
      const mm = String(today.getMonth() + 2).padStart(2, "0"); //January is 0!
      const yyyy = today.getFullYear();
      // console.log("this code run four");
      // console.log(yyyy + "-" + mm + "-" + dd)
      return yyyy + "-" + mm + "-" + dd;
    } else if (((today.getDate() == 31) && (today.getMonth() % 2 == 1))) {
      const today = new Date(checkInDate);
      // console.log(today.getMonth());
      const dd = String((0 + 1)).padStart(2, "0");
      const mm = String(today.getMonth() + 2).padStart(2, "0"); //January is 0!
      const yyyy = today.getFullYear();
      // console.log("this code run five");
      // console.log(yyyy + "-" + mm + "-" + dd)
      return yyyy + "-" + mm + "-" + dd;
    }
    else if ((today.getDate() == 29) && (today.getMonth() == 1)) {
      const today = new Date(checkInDate);
      const dd = String((0 + 1)).padStart(2, "0");
      const mm = String(today.getMonth() + 2).padStart(2, "0"); //January is 0!
      const yyyy = today.getFullYear();
      // console.log("this code run two")
      // console.log(yyyy + "-" + mm + "-" + dd);
      return yyyy + "-" + mm + "-" + dd;
    } else {
      const dd = String(today.getDate() + 1).padStart(2, "0");
      const mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
      const yyyy = today.getFullYear();
      // console.log("this code run three")
      return yyyy + "-" + mm + "-" + dd;
    }
  };


  return (
    <>
      <Helmet>
        <title>Venue and Accommodation Facilities for All Organizations | BLC</title>
        <meta name="description" content="Brac Learning Centres venue & accommodation reservation
facilities is available for all organizations. The space is organized to ensure a safe
and respectful environment." />
        <meta name="keywords" content="best venue for seminar, accommodation facilities, venue and
accommodation facilities, corporate training venues for rent, learning centre
reservation, conference venue with accommodation reservation, reserve learning
centre, venue for workshop, convention center reservation, class room for rent,
conference hall near me" />
      </Helmet>
      {/* <Hero_section heroVal ={props.valHero}/> */}
      {mailToast && BlcNotificationOne() || mailToastErr && BlcNotificationTwo()}
      <Parallax
        blur={{ min: -7, max: 7 }}
        bgImage={props.valReservation.backgroundImage.data[0].attributes.formats.large.url}
        strength={100}
        fluid
      >
        <div className="reservation-gap">
          <Container className="py-3">
            <h2 className="text-center">{props.valReservation.descriptionOne}</h2>
            <p style={{ textAlign: "center" }}>
              {props.valReservation.descriptionTwo}
            </p>
            {/* <p style={{color: 'grey', textAlign: 'center'}}>Your registration will be verfied prior to you arrival.</p> */}
            {/* <hr style={{height: '2px', color: 'gray'}}/> */}
          </Container>
          <Container className="py-4 d-flex justify-content-center">
            <Form variant="flush" className="form-background" noValidate validated={validated} onSubmit={handleSubmit}>
              <div style={{ color: "white" }}>
                <h4 className="py-4">Personal Information</h4>
                <Row className="mb-3">
                  <Form.Group as={Col} controlId="formGridFirstName">
                    <Form.Label>First Name*</Form.Label>
                    <Form.Control value={firstName} onChange={firstNameHandler} type="text" placeholder="First Name" required />
                    <Form.Control.Feedback type="invalid">
                      Please enter your first name.
                    </Form.Control.Feedback>
                  </Form.Group>

                  <Form.Group as={Col} controlId="formGridLastName">
                    <Form.Label>Last Name*</Form.Label>
                    <Form.Control value={lastName} onChange={lastNameHandler} type="text" placeholder="Last Name" required />
                    <Form.Control.Feedback type="invalid">
                      Please enter your last name.
                    </Form.Control.Feedback>
                  </Form.Group>
                </Row>

                <Row className="mb-3">
                  <Form.Group as={Col} controlId="formGridPhone">
                    <Form.Label>Phone*</Form.Label>
                    <Form.Control value={phoneNumber} onChange={phoneNumberHandler} type="phone" placeholder="(+880)" required />
                    <Form.Control.Feedback type="invalid">
                      Please enter your your name.
                    </Form.Control.Feedback>
                  </Form.Group>

                  <Form.Group as={Col} controlId="formGridEmail">
                    <Form.Label>E-mail*</Form.Label>
                    <Form.Control
                      value={userEmail}
                      onChange={emailHandler}
                      type="email"
                      placeholder="jhon@example.com"
                      required
                    />
                    <Form.Control.Feedback type="invalid">
                      Please enter your email name.
                    </Form.Control.Feedback>
                  </Form.Group>
                </Row>

                <Form.Group className="mb-3" controlId="formCompanyName">
                  <Form.Label>Company Name</Form.Label>
                  <Form.Control value={companyName} onChange={companynameHandler} type="text" placeholder="Company Name" />
                </Form.Group>

                <Form.Group className="mb-3" controlId="formStreetAddress">
                  <Form.Label>Street Address*</Form.Label>
                  <Form.Control value={streetAddress} onChange={streetAddressOneHandler} placeholder="Street Address" type="text" required />
                  <Form.Control.Feedback type="invalid">
                    Street address is required.
                  </Form.Control.Feedback>
                </Form.Group>

                <Form.Group className="mb-3" controlId="formStreetAddress2">
                  <Form.Label>Street Address Line 2</Form.Label>
                  <Form.Control value={streetAddressTwo} onChange={streetAddressTwoHandler} placeholder="Street Address Line 2" type="text" />
                </Form.Group>

                <Form.Group className="mb-3" controlId="formCity">
                  <Form.Label>City*</Form.Label>
                  <Form.Control value={cityName} onChange={cityNameHandler} placeholder="City/District" type="text" required />
                </Form.Group>

                <h4 className="py-4">Requirements*</h4>

                <Row className="mb-3">
                  <Form.Group as={Col} controlId="formGridRoomType">
                    <Form.Label>Service Type</Form.Label>
                    <Form.Select value={serviceType} onChange={serviceTypeHandler} type="text" placeholder="Choose Services" required>
                      <option>Choose Services</option>
                      <option>Accommodation</option>
                      <option>Venue</option>
                    </Form.Select>
                  </Form.Group>
                </Row>
                <Row className="mb-3">
                  <Form.Group as={Col} controlId="formGridRoomType">
                    <Form.Label>Room Type</Form.Label>
                    <Form.Select value={roomType} onChange={roomTypeHandler} type="text" placeholder="Choose Room Type" required>
                      <option>Choose Room Type</option>
                      <option> Guest Room (Single) </option>
                      <option> Guest Room (Double/Twin) </option>
                      <option> Hall Room </option>
                      <option> Class Room </option>
                      <option> Dormitory </option>
                    </Form.Select>
                  </Form.Group>

                  <Form.Group as={Col} controlId="formGridLocation">
                    <Form.Label>Location</Form.Label>
                    <Form.Select value={locationType} onChange={locationHandler} type="text" placeholder="Choose Location" required >
                      <option>Choose Location</option>
                      <option>Gulshan</option>
                      <option>Uttara</option>
                      <option>Barishal</option>
                      <option>Bogura</option>
                      <option>Chattagram</option>
                      <option>Cox's Bazar</option>
                      <option>Cumilla</option>
                      <option>Dinajpur</option>
                      <option>Faridpur</option>
                      <option>Jashore</option>
                      <option>Khulna</option>
                      <option>Madhupur</option>
                      <option>Mymenshing</option>
                      <option>Pabna</option>
                      <option>Rajshahi</option>
                      <option>Rangpur</option>
                      <option>Sreemangal</option>
                      <option>Sylhet</option>
                    </Form.Select>
                  </Form.Group>
                </Row>

                <Row className="mb-3">
                  <Form.Group as={Col} controlId="formGridRoomNo">
                    <Form.Label>Number of Room</Form.Label>
                    <Form.Control
                      value={numberOfRoom}
                      type="digits"
                      placeholder="type room number"
                      onChange={numberOfRoomHandler}
                      required
                    ></Form.Control>
                    <Form.Control.Feedback type="invalid">
                      Please enter number of room.
                    </Form.Control.Feedback>
                  </Form.Group>

                  <Form.Group as={Col} controlId="formGridPerson">
                    <Form.Label>Number of Person</Form.Label>
                    <Form.Control
                      value={numberOfPerson}
                      type="digits"
                      placeholder="type number of person"
                      onChange={numberOfPersonHandler}
                      required
                    ></Form.Control>
                    <Form.Control.Feedback type="invalid">
                      Please enter your person of numbers.
                    </Form.Control.Feedback>
                  </Form.Group>
                </Row>

                <Row className="mb-3">
                  <Form.Group as={Col} controlId="formGridStartDate">
                    <Form.Label>Check In</Form.Label>
                    <Form.Control
                      type="date"
                      data-date-format="dd/mm/yy"
                      name="date"
                      min={disablePastDate()}
                      placeholder="Due date"
                      value={checkInDate}
                      onChange={dateOneHandler}
                      required
                    />
                    <Form.Control.Feedback type="invalid">
                      Please enter your check in date.
                    </Form.Control.Feedback>
                  </Form.Group>

                  <Form.Group as={Col} controlId="formGridStartDate">
                    <Form.Label>Check Out</Form.Label>
                    <Form.Control
                      type="date"

                      name="begin"
                      min={blcCheckout()}
                      placeholder="dd-mm-yyyy"
                      value={checkOutDate}
                      onChange={dateTwoHandler}
                      required
                    />
                    <Form.Control.Feedback type="invalid">
                      Please enter your checkout data.
                    </Form.Control.Feedback>
                  </Form.Group>

                </Row>

                <Form.Group
                  className="mb-3"
                  as={Col}
                  controlId="formGridPurpose"
                >
                  <Form.Label>Purpose of visit</Form.Label>
                  <Form.Control
                    value={visitPurpose}
                    type="text"
                    placeholder="visit purpose"
                    onChange={visitPurposeHandler}
                    required
                  ></Form.Control>
                  <Form.Control.Feedback type="invalid">
                    Please enter your purpose of visit.
                  </Form.Control.Feedback>
                </Form.Group>

                <h4 className="py-4">Do you have any special requirements?</h4>
                <Row className="mb-3">
                  <Form.Group
                    className="mb-3"

                    controlId="exampleForm.ControlTextarea1"
                  >
                    <Form.Control
                      as="textarea"
                      type="text"
                      value={specialRequest}
                      onChange={specialRequestHandler}
                      rows={3}
                      style={{ height: "100px" }}
                      placeholder="Leave a text here..."
                    />
                  </Form.Group>
                </Row>
                {/* <Form.Group className="mb-3">
                  <Form.Check
                   type="checkbox"
                  value={termCondition}
                  onChange={termConditionHandler}
                    required
                    label="Agree to terms and conditions"
                    feedback="You must agree before submitting."
                    feedbackType="invalid"
                  />
                </Form.Group> */}
                <Button variant="primary" type="submit">
                  Submit
                </Button>
              </div>
            </Form>
          </Container>
        </div>
      </Parallax>

      <Blc_map />
      {/* <Blc_partner val={props.valPartner}></Blc_partner> */}
    </>
  );
};
export default Blc_Reservation;
